<template>
  <div>
    <div class="d-flex button-group"
         :class="{'justify-content-end': isNewPartner, 'justify-content-between': !isNewPartner}">
      <b-button class="history-btn" v-if="!isNewPartner" @click="openHistoryModal">{{$t('buttons.common.history')}}
      </b-button>
      <history-modal-content></history-modal-content>
      <b-button v-if="currentRoutePermissions.change_partner" variant="outline-success" @click="save" size="sm">
        {{ $t('buttons.common.save')}}
      </b-button>
    </div>
    <div class="d-flex justify-content-between toggle-container" @click="showCollapse = !showCollapse"
         :aria-expanded="showCollapse ? 'true' : 'false'"
         aria-controls="collapse">
      <h3>
        {{partnerLabel}}
      </h3>
      <div class="icons-wrapper">
        {{partnerInfo}}
        <icon name="angle-down" class="angle" v-if="showCollapse"></icon>
        <icon name="angle-right" class="angle" v-else></icon>
      </div>
    </div>
    <partner-contact-modal :id="this.param">
    </partner-contact-modal>
    <div>
      <b-collapse id="collapse" v-model="showCollapse">
        <div class="form-info">
          <div class="col">
            <div>
              <label>{{$t('labels.partner.role')}}</label>
              <multiselect v-model="partnerData.roles" :max-height="200"
                           placeholder="" label="name" track-by="name"
                           :options="roles" :multiple="true"
                           :class="{ required: !partnerData.roles.length && isLoadedData}"
                           :close-on-select="false"></multiselect>
            </div>
            <div>
              <label>{{$t('labels.partner.partner_name')}}</label>
              <input class="form-control" placeholder=""
                     v-model="partnerData.name"
                     :class="{ required: !partnerData.name && isLoadedData}">
            </div>
            <div>
              <label>{{$t('labels.partner.official_name')}}</label>
              <input class="form-control" placeholder=""
                     v-model="partnerData.official_name"
                     :class="{ required: !partnerData.official_name && isLoadedData}">
            </div>
            <div>
              <label>{{$t('labels.partner.company_code')}}</label>
              <input class="form-control" placeholder=""
                     v-model="partnerData.company_code">
            </div>
            <div>
              <label>{{$t('labels.partner.language')}}</label>
              <multiselect v-model="partnerData.language" :max-height="200"
                           placeholder="" label="name" track-by="name"
                           :options="languages"
                           :class="{ required: !partnerData.language && isLoadedData}"
                           :close-on-select="true"></multiselect>
            </div>
          </div>
          <div class="col">
            <div>
              <label>{{$t('labels.partner.country')}}</label>
              <multiselect v-model="partnerData.country" :max-height="200"
                           placeholder="" label="name" track-by="name"
                           :options="countries"
                           :class="{ required: !partnerData.country && isLoadedData}"
                           :close-on-select="true"></multiselect>
            </div>
            <div>
              <label>{{$t('labels.common.county')}}</label>
              <input class="form-control" v-model="partnerData.county">
            </div>
            <div>
              <label>{{$t('labels.partner.city')}}</label>
              <input class="form-control" placeholder="" v-model="partnerData.city">
            </div>
            <div>
              <label>{{$t('labels.partner.street')}}</label>
              <input class="form-control" placeholder="" v-model="partnerData.street">
            </div>
            <div>
              <label>{{$t('labels.partner.postal_code')}}</label>
              <input class="form-control" placeholder="" v-model="partnerData.postcode">
            </div>
          </div>
          <div class="col">
            <div>
              <label>{{$t('labels.partner.vat')}}</label>
              <input class="form-control" placeholder="" v-model="partnerData.vat_code">
            </div>
            <div>
              <label>{{$t('labels.partner.register_code')}}</label>
              <input class="form-control" placeholder="" v-model="partnerData.reg_code">
            </div>
            <div class="checkbox-wrapper">
              <label for="status">{{$t('labels.partner.is_active')}}</label>
              <input id="status" class="mr-3" type="checkbox" v-model="partnerData.is_active">
              <label for="private_owner">{{$t('labels.partner.private_owner')}}</label>
              <input id="private_owner" type="checkbox" v-model="partnerData.private_owner">
            </div>
            <div>
              <label>{{$t('labels.common.percent')}}, %</label>
              <float-input v-model="partnerData.percent_difference" placeholder=""> </float-input>
            </div>
            <div style="margin-top: 8px">
              <label>EORI code</label>
              <input class="form-control" v-model="partnerData.EORI_code" placeholder="">
            </div>
            <div style="margin-top: 8px">
              <label>{{$t('labels.common.notes')}}</label>
              <b-form-textarea class="form-control" v-model="partnerData.notes" placeholder="">
              </b-form-textarea>
            </div>
          </div>
        </div>
      </b-collapse>
    </div>
    <div>
      <b-card no-body>
        <b-tabs card v-if="isLoadedData">
          <b-tab active v-if="tabsRestrictions['main']">
            <template slot="title">
              <portal-target name="main_tab"></portal-target>
            </template>
            <portal to="main_tab">{{$t('tabs.partner.main')}}</portal>
            <div>
              <b-row>
                <b-col>
                  <label class="underline">{{$t('labels.partner.bank_requisites')}}</label><br/>
                  <label>{{$t('labels.partner.bank')}}</label>
                  <input class="form-control" placeholder=""
                         v-model="partnerData.bank">
                  <label>{{$t('labels.partner.account_nr')}} (IBAN)</label>
                  <input class="form-control" placeholder=""
                         v-model="partnerData.account_no">
                  <label>SWIFT (BIC)</label>
                  <input class="form-control" placeholder=""
                         v-model="partnerData.swift">
                  <label>{{$t('labels.partner.bank_address')}}</label>
                  <input class="form-control" placeholder=""
                         v-model="partnerData.bank_address">
                </b-col>
                <b-col>
                  <label class="underline">{{$t('labels.partner.communication')}}</label><br/>
                  <label>{{$t('labels.partner.phone')}}</label>
                  <vue-tel-input class="form-control phone-number"
                                 id="partner_telephone"
                                 placeholder=""
                                 v-model="partnerData.phone">
                  </vue-tel-input>
                  <label>{{$t('labels.partner.fax')}}</label>
                  <vue-tel-input class="form-control phone-number"
                                 id="partner_fax"
                                 placeholder=""
                                 v-model="partnerData.fax">
                  </vue-tel-input>
                  <label>{{$t('labels.partner.website')}}</label>
                  <input class="form-control" placeholder=""
                         v-model="partnerData.website">
                  <label>Email</label>
                  <input class="form-control" placeholder="" v-model="partnerData.email">
                </b-col>
                <b-col>
                  <label class="underline">{{$t('labels.common.additional')}}</label><br/>
                  <label>{{$t('labels.partner.invoice_prefix')}}</label>
                  <input class="form-control" placeholder=""
                         v-model="partnerData.invoice_prefix">
                  <label>{{$t('labels.partner.invoice_email')}}</label>
                  <input class="form-control" placeholder="" v-model="partnerData.invoice_email" />
                  <b-form-text id="input-live-help">{{$t('labels.partner.invoice_email_help')}}</b-form-text>
                </b-col>
              </b-row>
            </div>
          </b-tab>
          <b-tab v-if="tabsRestrictions['contacts']" @click="loadPartnerContacts">
            <template slot="title">
              <portal-target name="delivery_addresses_tab"></portal-target>
            </template>
            <portal to="delivery_addresses_tab">
              {{$t('tabs.partner.delivery_addresses')}}
            </portal>
            <b-row>
              <b-col>
                <div class="d-flex justify-content-end button-group">
                  <b-btn v-if="currentRoutePermissions.change_partner" variant="outline-success"
                         size="sm" @click="openPartnerContactModal">
                    {{$t('buttons.partner.add_contact')}}
                  </b-btn>
                  <b-btn v-if="currentRoutePermissions.change_partner" variant="outline-danger"
                         size="sm" @click="deletePartnerContacts">
                    {{$t('buttons.partner.delete_contact')}}
                  </b-btn>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <ag-grid-vue class="ag-theme-balham" :columnDefs="partnerContactsGridColumns"
                             :gridOptions="partnerContactsGrid"
                             :style="gridHeight" :rowData="partnerContacts"
                             @rowDoubleClicked="loadPartnerContactData"
                             :postProcessPopup="postProcessPopup">
                </ag-grid-vue>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab v-if="tabsRestrictions['commissions']" @click="loadPartnerCommissions">
            <template slot="title">
              <portal-target name="commissions_tab"></portal-target>
            </template>
            <portal to="commissions_tab">{{$t('tabs.partner.commissions')}}</portal>
            <b-row>
              <b-col>
                <div class="d-flex justify-content-between button-group">
                  <div>
                    {{$t('labels.common.selected')}}: {{selectedCommissionsCount}}
                    <b-btn v-if="currentRoutePermissions.change_partner" variant="danger" size="sm"
                           @click="deletePartnerCommission">
                      {{$t('buttons.partner.delete_commission')}}
                    </b-btn>
                  </div>
                  <div>
                    <partner-commission-modal :partner_id="this.param"></partner-commission-modal>
                    <b-btn v-if="currentRoutePermissions.change_partner" variant="success" size="sm"
                           @click="openPartnerCommissionModal('create')">
                      {{$t('buttons.partner.create_commission')}}
                    </b-btn>
                    <b-btn v-if="(isRoleSupplier || isRoleCustomer) && currentRoutePermissions.change_partner"
                           variant="success" size="sm"
                           @click="openPartnerCommissionModal('copy')">
                      {{$t('buttons.partner.add_commission')}}
                    </b-btn>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <ag-grid-vue class="ag-theme-balham" :columnDefs="agentCommissionsColumns"
                             :gridOptions="agentCommissionsGrid"
                             :style="gridHeight" :rowData="agentCommissions"
                             @rowDoubleClicked="editCommission"
                             @rowDataChanged="countSelectedCommissions"
                             @rowSelected="countSelectedCommissions"
                             :postProcessPopup="postProcessPopup">
                </ag-grid-vue>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab v-if="tabsRestrictions['documents']" @click="loadDocuments(true)">
            <template slot="title">
              <portal-target name="documents_tab"></portal-target>
            </template>
            <portal to="documents_tab">
              {{$t('tabs.common.documents')}}
            </portal>
            <app-documents :documents="documents" :isCollapse="showCollapse" :url="commonUrl + 'attachments/'"
                           @loadDocuments="loadDocuments"></app-documents>
          </b-tab>
          <b-tab v-if="tabsRestrictions['comments']" @click="loadComments(true)">
            <template slot="title">
              <portal-target name="comments_tab"></portal-target>
            </template>
            <portal to="comments_tab">{{$t('tabs.common.comments')}}</portal>
            <app-comments :comments="comments" :url="commonUrl + 'comments/'"
                          @loadComments="loadComments"></app-comments>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
  import { AgGridVue } from 'ag-grid-vue';
  import { mapGetters, mapState } from 'vuex';
  import Multiselect from 'vue-multiselect';
  import Datepicker from 'vue2-datepicker';
  import { VueTelInput } from 'vue-tel-input';
  import {
    handlerResponse,
    setNotifyData,
    getArrayByProperty,
  } from '@/helpers/commonHelpers';
  import { notificationsRenderer } from '@/helpers/renderHelpers';
  import Comments from '@/components/common/Comments';
  import Documents from '@/components/common/Documents';
  import FloatInput from '@/components/common/FloatInput';
  import HistoryModalContent from '@/components/modals/HistoryModal';
  import PartnerContactModal from '@/components/modals/PartnerContactModal.vue';
  import PartnerCommissionModal from '@/components/modals/PartnerCommissionModal.vue';
  import { gridMixins } from '@/mixins';
  import { PRICE_USAGE_CONTRACT, PRICE_USAGE_PRICE_LIST } from '@/constants'

  export default {
    mixins: [gridMixins],
    components: {
      Multiselect,
      Datepicker,
      VueTelInput,
      'ag-grid-vue': AgGridVue,
      'app-comments': Comments,
      'app-documents': Documents,
      HistoryModalContent,
      PartnerContactModal,
      PartnerCommissionModal,
      FloatInput
    },
    data() {
      return {
        isLoadedData: false,
        showCollapse: true,
        selectedCommissionsCount: 0,
        partnerData: {
          roles: [],
          name: '',
          phone: '',
          fax: '',
          official_name: '',
          country: null,
          company_code: '',
          city: '',
          bank: '',
          street: '',
          is_active: true,
          account_no: '',
          vat_code: '',
          reg_code: '',
          incoterms: [],
          payment_terms: [],
          invoice_prefix: '',
          postcode: '',
          swift: '',
          email: '',
          website: '',
          notes: '',
          created: '',
          language: '',
          county: '',
          bank_address: '',
          price_usage: '',
          invoice_email: '',
          EORI_code: ''
        },
      }
    },
    methods: {
      openHistoryModal() {
        this.$root.$emit('openHistoryModal', this.historySettings);
      },
      async save() {
        const savedData = this.prepareSavedData();
        if (this.isNewPartner) {
          try {
            const response = await this.$http.post(`partner/partners/`, savedData).then(handlerResponse);
            this.partnerData = {...response};
            this.$notify(setNotifyData('Success', 'Partner has been created!', 'success'));
            await this.$router.push({path: `/partners/${response.id}`});
          } catch (error) {
            console.log(error);
            this.handleErrorResponse(error)
          }
        } else {
          try {
            await this.$http.put(`partner/partners/${this.param}/`, savedData).then(handlerResponse);
            this.$notify(setNotifyData('Success', 'Partner has been saved!', 'success'));
          } catch (error) {
            this.handleErrorResponse(error)
          }
        }
      },
      handleErrorResponse (error) {
        if (['object'].includes(typeof error.body)) {
          for (const field in error.body) {
            Object.entries(error.body[field]).forEach(([key, value]) => {
              let errorText
              if (value.toString() === 'Invoice email should contain unique values.') {
                errorText = `${value.toString()}`
              } else {
                errorText = `For ${field} on position ${1 + +key} an error occurred: ${value.toString()}`
              }
              notificationsRenderer(errorText, 'error')
            })
          }
        } else {
          notificationsRenderer(error.body, 'error')
        }
      },
      async getPartnerInfo() {
        const response = await this.$http.get(`partner/partners/${this.param}/`).then(handlerResponse);
        this.partnerData = {...response};
        this.$store.dispatch('location/setPathName', response.name);
        this.isLoadedData = true;
      },
      prepareInvoiceEmail() {
        return this.partnerData.invoice_email.length
          ? this.partnerData.invoice_email.toString().split(',')
          : []
      },
      prepareSavedData() {
        const savedData = {
          country: this.partnerData.country && this.partnerData.country.short_name,
          name: this.partnerData.name,
          phone: this.partnerData.phone,
          fax: this.partnerData.fax,
          official_name: this.partnerData.official_name,
          company_code: this.partnerData.company_code,
          city: this.partnerData.city,
          bank: this.partnerData.bank,
          street: this.partnerData.street,
          is_active: this.partnerData.is_active,
          account_no: this.partnerData.account_no,
          vat_code: this.partnerData.vat_code,
          reg_code: this.partnerData.reg_code,
          invoice_prefix: this.partnerData.invoice_prefix,
          postcode: this.partnerData.postcode,
          swift: this.partnerData.swift,
          email: this.partnerData.email,
          website: this.partnerData.website,
          language: this.partnerData.language ? this.partnerData.language.id : '',
          notes: this.partnerData.notes,
          county: this.partnerData.county,
          bank_address: this.partnerData.bank_address,
          price_usage: this.partnerData.price_usage || PRICE_USAGE_CONTRACT,
          private_owner: this.partnerData.private_owner,
          percent_difference: this.partnerData.percent_difference,
          invoice_email: this.prepareInvoiceEmail(),
          EORI_code: this.partnerData.EORI_code
        };
        this.roles.forEach((e) => {
          savedData[e.key] = !!this.partnerData.roles.find(item => item.key === e.key);
        });

        return savedData;
      },
      loadPartnerContacts() {
        this.$store.dispatch('generalPartner/loadPartnerContacts', {id: this.param});
      },
      loadComments(cacheFlag) {
        if (cacheFlag) {
          this.$store.cache.dispatch('generalPartner/loadCommentsList', {id: this.param});
        } else {
          this.$store.dispatch('generalPartner/loadCommentsList', {id: this.param});
        }
      },
      loadDocuments(cacheFlag) {
        if (cacheFlag) {
          this.$store.cache.dispatch('generalPartner/loadDocumentsList', {id: this.param});
        } else {
          this.$store.dispatch('generalPartner/loadDocumentsList', {id: this.param});
        }
      },
      openPartnerContactModal(contactData) {
        this.$root.$emit('openPartnerContactModal', {...{isNew: true}, ...contactData});
      },
      loadPartnerContactData(params) {
        const partnerContactId = params.data.id;
        this.$http.get(`partner/partners/${this.param}/delivery_addresses/${partnerContactId}/`).then(handlerResponse)
          .then((response) => {
            this.openPartnerContactModal({...response, ...{isNew: false}});
          })
      },
      deletePartnerContacts() {
        const id = getArrayByProperty(this.partnerContactsGrid.api.getSelectedRows(), 'id').toString();
        if (id.length) {
          this.$http.delete(`${this.commonUrl}delivery_addresses/`, {body: {id}}).then((response) => {
            this.$notify(setNotifyData('Success', response.body, 'success'));
            this.loadPartnerContacts()
          }).catch((response) => {
            this.$notify(setNotifyData('', response.body, 'error'));
          });
        } else {
          this.$notify(setNotifyData('Select partner contacts for removing', '', 'warn'));
        }
      },
      loadPartnerCommissions() {
        const searchData = {
          customers: this.isRoleCustomer ? this.param : '',
          agents: this.isRoleSaleAgent || this.isRolePurchaseAgent ? this.param : '',
          suppliers: this.isRoleSupplier ? this.param : ''
        };
        if (this.isRoleSaleAgent || this.isRoleCustomer) {
          this.$store.dispatch('accounting/loadSaleAgentCommissionsList', searchData);
        } else if (this.isRolePurchaseAgent || this.isRoleSupplier) {
          this.$store.dispatch('accounting/loadPurchaseAgentCommissionsList', searchData);
        }
      },
      async openPartnerCommissionModal(mode) {
        const defaultData = {
          mode: mode,
          roles: {
            customer: this.isRoleCustomer,
            sale_agent: this.isRoleSaleAgent,
            purchase_agent: this.isRolePurchaseAgent,
            supplier: this.isRoleSupplier
          },
          commissionData: {
            customer: this.isRoleCustomer ? {id: this.param, name: this.partnerData.name} : null,
            sale_agent: this.isRoleSaleAgent && !this.isRoleCustomer ? {id: this.param, name: this.partnerData.name} : null,
            purchase_agent: this.isRolePurchaseAgent && !this.isRoleSupplier ? {id: this.param, name: this.partnerData.name} : null,
            supplier: this.isRoleSupplier ? {id: this.param, name: this.partnerData.name} : null
          }
        };
        if (this.isRoleSaleAgent || this.isRoleCustomer) {
          await this.$store.dispatch('partners/getSaleAgents');
        } else if (this.isRolePurchaseAgent || this.isRoleSupplier){
          await this.$store.dispatch('partners/getPurchaseAgents');
        }
        await this.loadCommissionTypes();
        await this.$root.$emit('openPartnerCommissionModal', defaultData);
      },
      editCommission(data) {
        const agentRole = this.isRoleSaleAgent || this.isRoleCustomer ? 'sale' : 'purchase';
        this.$http.get(`accounting/${agentRole}_agent_commissions/${data.data.id}/`).then(handlerResponse).then((response) => {
          const defaultData = {
            mode: 'edit',
            roles: {
              customer: this.isRoleCustomer,
              sale_agent: this.isRoleSaleAgent,
              purchase_agent: this.isRolePurchaseAgent,
              supplier: this.isRoleSupplier
            },
            commissionData: {...response}
          };
          this.$root.$emit('openPartnerCommissionModal', defaultData);
        });
      },
      deletePartnerCommission() {
        const agentRole = this.isRoleSaleAgent || this.isRoleCustomer ? 'sale' : 'purchase';
        if (this.agentCommissionsGrid.api.getSelectedRows().length) {
          const ids = getArrayByProperty(this.agentCommissionsGrid.api.getSelectedRows(), 'id');
          this.$http.delete(`accounting/${agentRole}_agent_commissions/`, {body: {ids: ids}}).then((response) => {
            this.loadPartnerCommissions();
            this.$notify(setNotifyData('Success', response.body, 'success'));
          }).catch((error) => {
            console.log(error);
            this.$notify(setNotifyData('Error', error.body, 'error'));
          });
        } else {
          this.$notify(setNotifyData('Error', 'Select commissions for removing', 'error'));
        }
      },
      countSelectedCommissions() {
        this.selectedCommissionsCount = getArrayByProperty(this.agentCommissionsGrid.api.getSelectedRows(), 'id') ?
          getArrayByProperty(this.agentCommissionsGrid.api.getSelectedRows(), 'id').length : 0
      },
      clearData() {
        this.$store.cache.delete('generalPartner/loadDocumentsList', {id: this.param});
        this.$store.cache.delete('generalPartner/loadCommentsList', {id: this.param});
        if (this.comments.length) {
          this.$store.commit('generalPartner/setCommentsList', []);
        }
        if (this.documents.length) {
          this.$store.commit('generalPartner/setDocumentsList', []);
        }
        this.$store.commit('generalPartner/setPartnerContacts', []);
      },
      changePriceUsage (e) {
        const { value } = e
        this.partnerData.price_usage = value ? PRICE_USAGE_CONTRACT : PRICE_USAGE_PRICE_LIST
      },
      async loadCommissionTypes() {
        if (this.isRoleCustomer || this.isRoleSaleAgent) {
          await this.$store.dispatch('generic/loadCommissionTypes');
        } else {
          await this.$store.dispatch('generic/loadCommissionTypes', 'purchase_agent');
        }
      }
    },
    computed: {
      ...mapState('generic', ['languages', 'currencies', 'incoterms', 'commissionTypes', 'currentRoutePermissions']),
      ...mapState('woodware', ['countries', 'payment_terms']),
      ...mapState('generalPartner', ['partnerContacts', 'documents', 'comments', 'partnerContactsGridColumns',
        'partnerCommissions']),
      ...mapState('generalPartners', ['roles']),
      ...mapState('woodware', ['measure_types']),
      ...mapState('accounting', ['agentCommissions', 'agentCommissionsCount', 'agentCommissionsColumns', 'agentCommissionsPinnedRowData']),
      ...mapGetters('accounting', ['agentCommissionsGrid']),
      ...mapGetters('generalPartner', {
        partnerContactsGrid: 'partnerContactsGrid'
      }),
      param() {
        return this.$route.params.id;
      },
      commonUrl() {
        return `partner/partners/${this.param}/`;
      },
      isNewPartner() {
        return this.param === 'new';
      },
      isRoleCustomer() {
        return !!this.partnerData.roles.find(role => role.key === 'customer');
      },
      isRoleSaleAgent() {
        return !!this.partnerData.roles.find(role => role.key === 'sale_agent');
      },
      isRolePurchaseAgent() {
        return !!this.partnerData.roles.find(role => role.key === 'purchase_agent');
      },
      isRoleSupplier() {
        return !!this.partnerData.roles.find(role => role.key === 'supplier');
      },
      partnerLabel() {
        return this.isNewPartner ? `${this.$i18n.t('common_content.new')} ${this.$i18n.t('common_content.partner')}` :
          `${this.$i18n.t('common_content.partner')} / ${this.partnerData.name}`;
      },
      partnerInfo() {
        return this.isNewPartner ? '' : `${this.partnerData.created}`
      },
      historySettings() {
        return {url: `partner/?id=${this.param}`, title: this.partnerLabel.split('/')[1]}
      },
      tabsRestrictions() {
        return {
          'main': this.isLoadedData,
          'contacts': this.isLoadedData && !this.isNewPartner,
          'commissions': this.isLoadedData && (this.isRoleCustomer || this.isRoleSaleAgent || this.isRolePurchaseAgent || this.isRoleSupplier) && !this.isNewPartner,
          'comments': this.isLoadedData && !this.isNewPartner,
          'documents': this.isLoadedData && !this.isNewPartner
        }
      },
      gridHeight() {
        if (window.innerHeight > 1024) {
          return this.showCollapse ? {height: 'calc(100vh - 620px)'} : {height: 'calc(100vh - 280px)'};
        } else {
          return this.showCollapse ? {height: '400px'} : {height: '350px'};
        }
      }
    },
    async beforeMount() {
      this.$store.cache.dispatch('woodware/getCountries');
      this.$store.cache.dispatch('generalPartners/loadRoles');
      this.$store.cache.dispatch('generic/getCurrencies');
      this.$store.cache.dispatch('generic/loadLanguages');
      if (!this.isNewPartner) {
        await this.getPartnerInfo();
      } else {
        this.isLoadedData = true;
      }
    },
    mounted() {
      this.$root.$on('updatePartnerCommissionsList', () => {
        this.loadPartnerCommissions();
      });
    },
    beforeDestroy() {
      this.$root.$off('updatePartnerCommissionsList');
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.clearData();
      });
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/modules/general/partners/Partner.vue